import { useError } from 'src/hooks/useError'
import { UserTranslator } from 'src/translators'
import { useGetExternalUserQuery } from 'src/types/generated'

type Input = {
  userId: number
}

export const useGetExternalUser = ({ userId }: Input) => {
  const { loading, data, error, refetch } = useGetExternalUserQuery({ variables: { userId } })
  const { toErrorEntities } = useError()

  return {
    loading,
    externalUser:
      data && data.externalUser
        ? UserTranslator.toExternalUserDetailEntity(data.externalUser)
        : null,
    errors: error ? toErrorEntities(error) : null,
    refetch,
  }
}
